export const management = {
  managerName: {
    title: 'Building manager name',
    type: 'simple-text',
    value: ''
  },
  managerPhoneWork: {
    title: 'Building manager phone (work)',
    type: 'phone',
    value: ''
  },
  phoneWork: {
    title: 'Phone (work)',
    type: 'phone',
    value: ''
  },
  phoneMobile: {
    title: 'Phone (mobile)',
    type: 'mobile',
    value: ''
  },
  emailPrimary: {
    title: 'Email (primary)',
    type: 'email',
    value: ''
  },
  emailAlternative: {
    title: 'Email (alternative)',
    type: 'email',
    value: ''
  }
}
